import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.47 6.205a.75.75 0 0 1 1.061 0l5.47 5.47 5.47-5.47a.75.75 0 0 1 1.061 1.061l-5.47 5.47 5.47 5.47a.75.75 0 0 1-1.061 1.061L12 13.796l-5.47 5.47a.75.75 0 0 1-1.061-1.061l5.47-5.47-5.47-5.47a.75.75 0 0 1 0-1.061z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const XMarkIcon = ForwardRef;